import { Component, OnDestroy, OnInit } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UserTypeWithOrders } from '../../../../../../shared/schemas/userSchema';
import { addUserToStore } from '../../../store/slices/usersSlice/usersSlice.actions';
import { selectAllUsers } from '../../../store/slices/usersSlice/usersSlice.selector';
import { AppStore } from '../../../store/store';
import { UsersService } from '../services/users.service';
import labels from './data/overall-table.json';

@Component({
  selector: 'app-overall-table',
  templateUrl: './overall-table.component.html',
  styleUrl: './overall-table.component.scss',
})
export class OverallTableComponent implements OnInit, OnDestroy {
  usersList$: Observable<UserTypeWithOrders[]> = this.store.pipe(select(selectAllUsers));
  header: string = labels.header;
  fullName: string = labels.fullName;
  nedarim: string = labels.nedarim;
  commits: string = labels.commit;
  total: string = labels.total;

  private destroy$ = new Subject<void>();

  constructor(
    private userService: UsersService,
    private store: Store<AppStore>,
  ) {}

  ngOnInit(): void {
    // Always fetch on mount — the store may contain just the logged-in user
    // from session restore, which is not a sufficient "we have all users"
    // signal. The reducer upserts, so re-fetching is safe and keeps the
    // cache fresh on every navigation.
    this.fetchUsers();
  }

  private fetchUsers(): void {
    this.userService
      .getUsers()
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (fetched) =>
          fetched.forEach((user) => this.store.dispatch(addUserToStore({ user }))),
        error: (err) => console.error('Error fetching users:', err),
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
